import React, { useEffect, useState } from "react";
import { auditJobSummaryData } from "../audit-inventory.services";
import WmsButton from "../../components/WmsButton/WmsButton";
import "./audit-inventory-summary.scss";
import WmsContainer from "../../components/WmsContainer/WmsContainer";
import WmsGrid from "../../components/WmsGrid/WmsGrid";
import { StringWms } from "../../../../assets/ts/StringWms";
import * as auditInventorySummaryGridConfig from "./audit-inventory-summary-grid-configuration";
import * as GlobalService from "../../../react/global_services";

interface Props {
    isShowSummary: boolean;
    selectedAuditJob: any;
    onExitAuditSummary(): void;
    selector: string;
    facId: number;
}

declare var window: any;
const { $ } = window;

const AuditInventorySummary: React.FC<Props> = (props: Props): any => {
    const selector = props.selector + "auditInventorySummary";
    const [auditSummaryData, setAuditSummaryData] = useState<any>(null);
    const auditSummeryGridHeaders = StringWms.convertSringToOption(
        window.translate("Audit_Inventory_Summary_Grid_Headers")
    );

    const auditInventorySummaryGridSchema = auditInventorySummaryGridConfig.auditInventorySummaryGridSchema();
    const auditResultsColumns = auditInventorySummaryGridConfig.auditResultsColumns(auditSummeryGridHeaders);

    useEffect(() => {
        getAuditJobSummaryData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedAuditJob]);

    const getAuditJobSummaryData = () => {
        if (props?.selectedAuditJob?.EditUri && [2, 3].includes(parseInt(props?.selectedAuditJob?.Status))) {
            const holder = $(".audit-inventory-summary-holder");
            kendo.ui.progress($(holder), true);
            auditJobSummaryData(props.selectedAuditJob.EditUri)
                .then((response: any) => {
                    const auditResults = response?.data?.auditResults?.map((item: any) => {
                        item.muLabelName = item.palletIdentifier?.nameKey?.name || "";
                        item.locationName = item.locationIdentifier?.nameKey?.name || "";
                        item.sku = item.itemIdentifier?.sku || "";
                        item.customerName = item.customerIdentifier?.name || "";
                        item.expirationDate = item.expirationDate
                            ? kendo.toString(kendo.parseDate(item.expirationDate), "MM/dd/yyyy")
                            : "";
                        return item;
                    });
                    response.data.auditResults = auditResults;

                    setAuditSummaryData(response?.data);
                })
                .finally(() => {
                    kendo.ui.progress($(holder), false);
                });
        } else {
            props.onExitAuditSummary();
        }
    };

    const getParsedDate = (date: string) => {
        if (!date) return "";
        return new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        }).format(new Date(date));
    };

    const downloadCSV = () => {
        const gridDomSelector = "#" + selector + "GridAuditResults";
        var grid = $(gridDomSelector).data("kendoGrid");
        var dataSource = grid.dataSource;
        var data = dataSource.data();
        var sort = dataSource.sort() || [];
        var query = new kendo.data.Query(data) as any;
        var filter = dataSource.filter();
        var sortedData = query?.sort(sort)?.filter(filter)?.data || [];

        //Job Info Array
        const jobInfoArray = [
            `Warehouse: ${auditSummaryData?.facilityIdentifier?.name ?? "-"}`,
            `Job Name: ${auditSummaryData?.jobName ?? "-"}`,
            `Audit Date: ${getParsedDate(auditSummaryData?.auditDate) ?? "-"}`,
            `Auditor: ${auditSummaryData?.auditor ?? "-"}`,
            `Audit Type: ${auditSummaryData?.auditType ?? "-"}`,
            `Collect MUs and track-bys: ${auditSummaryData?.useTrackBys ? "Yes" : "No"}`,
        ].join("\n");

        GlobalService.exportGridtoCSV(
            sortedData,
            gridDomSelector,
            `AuditInventoryJobSummary-${getParsedDate(props.selectedAuditJob?.ClosedDate)}`,
            jobInfoArray
        );
    };

    return (
        <div className="audit-inventory-summary">
            <div className="audit-inventory-summary-header">
                <WmsButton
                    label={window.translate("Audit_Inventory_Summary_Download_CSV_Label")}
                    wmsSelector={selector + "ButtonDownloadCSV"}
                    onClickFunc={downloadCSV}
                    icon={"fa-file-export"}
                    buttonType="green"
                />
                <WmsButton
                    label={window.translate("Label_Exit")}
                    wmsSelector={selector + "ButtonExit"}
                    onClickFunc={props.onExitAuditSummary}
                    icon={"fa-sign-out-alt"}
                    buttonType="orange"
                />
            </div>
            <div className="audit-inventory-summary-content">
                <div className="wms-content-wrapper">
                    <WmsContainer title={window.translate("Audit_Inventory_Summary_Job_Info")}>
                        <div className="wms-static-content-wrapper">
                            <div className="wms-content">
                                <div className="wms-data-items">
                                    <label>{window.translate("Audit_Inventory_Summary_Label_Warehouse")}: </label>
                                    <span>{auditSummaryData?.facilityIdentifier?.name}</span>
                                </div>
                                <div className="wms-data-items">
                                    <label>{window.translate("Audit_Inventory_Summary_Label_Job_Name")}: </label>
                                    <span>{auditSummaryData?.jobName}</span>
                                </div>
                                <div className="wms-data-items">
                                    <label>{window.translate("Audit_Inventory_Summary_Label_Audit_Date")}: </label>
                                    <span>{getParsedDate(auditSummaryData?.auditDate)}</span>
                                </div>
                                <div className="wms-data-items">
                                    <label>{window.translate("Audit_Inventory_Summary_Label_Auditor")}: </label>
                                    <span>{auditSummaryData?.auditor}</span>
                                </div>
                            </div>
                            <div className="wms-content">
                                <div className="wms-data-items">
                                    <label>{window.translate("Audit_Inventory_Summary_Label_Audit_Type")}: </label>
                                    <span>{auditSummaryData?.auditType}</span>
                                </div>
                                <div className="wms-data-items">
                                    <label>
                                        {window.translate("Audit_Inventory_Summary_Label_Audit_Collect_MUs_Track_Bys")}:
                                    </label>
                                    <span> {auditSummaryData?.useTrackBys ? "Yes" : "No"}</span>
                                </div>
                            </div>
                        </div>
                    </WmsContainer>
                    <WmsContainer title={window.translate("Audit_Inventory_Summary_Label_Audit_Results")}>
                        <WmsGrid
                            id={selector + "GridAuditResults"}
                            wmsSelector={selector + "GridAuditResults"}
                            gridKeySelection={"sku"}
                            gridName={selector + "GridAuditResults"}
                            gridHeight={450}
                            isAlignIndexesByProperty={true}
                            virtual={false}
                            columns={auditResultsColumns}
                            schema={auditInventorySummaryGridSchema}
                            showGridSummary={false}
                            onSelection={() => {}}
                            clickEventOfContextMenu={() => null}
                            shawCheckbox={false}
                            showGridResult={false}
                            staticGridData={auditSummaryData?.auditResults || []}
                            showSortColumns={true}
                            onDataBound={() => {}}
                            gridEditable={false}
                            onEdit={() => {}}
                            onGridSave={() => {}}
                            onChange={() => {}}
                            menu={[]}
                        />
                    </WmsContainer>
                </div>
            </div>
        </div>
    );
};

export default AuditInventorySummary;
